import React from "react";

const Widecard = ({ url, image, where, from, to, title }) => (
  <a href={url} target="_blank" rel="noreferrer" className="edu-card">
    <img src={image} className="edu-logo" alt={where} />
    <div className="edu-info">
      <div className="edu-title">{title}</div>
      <div className="edu-org">{where}</div>
    </div>
    <div className="edu-years">
      {from} – {to}
    </div>
  </a>
);

export default Widecard;
